


// Generated from io.spcfy.orders.samplemeta.enums.TrapType

export type TrapTypeKey =
  "TOWNES_STYLE_MALAISE_TRAP" |
  "BARTAK_STYLE_MALAISE_TRAP" |
  "SLAM_TRAP" |
  "EZ_MALAISE_TRAP" |
  "WINDOW_MALAISE_TRAP" |
  "CLASSIC_MALAISE_TRAP" |
  "PITFALL_TRAP" |
  "BARRIER_PITFALL_TRAP" |
  "PAN_TRAP" |
  "STICKY_TRAP" |
  "LIGHT_TRAP" |
  "UV_LIGHT_TRAP" |
  "LED_LIGHT_TRAP" |
  "ROBINSON_TRAP" |
  "HEATH_TRAP" |
  "LINDGREN_FUNNEL_TRAP" |
  "WINDOW_FLIGHT_TRAP" |
  "WINKLER_EXTRACTOR" |
  "BERLESE_TULLGREN_FUNNEL" |
  "FLIGHT_INTERCEPTION_TRAP" |
  "EMERGENCE_TRAP" |
  "FEROMONE_TRAP" |
  "BAIT_TRAP" |
  "CARRION_TRAP" |
  "BEER_TRAP" |
  "SLF_CIRCLE_TRAP" |
  "CONE_TRAP" |
  "DELTA_TRAP";


export interface TrapTypeDTO {
  key: TrapTypeKey;
  label: string;    
}


export const TrapTypes: Record<TrapTypeKey, TrapTypeDTO> = {
  TOWNES_STYLE_MALAISE_TRAP: { key: "TOWNES_STYLE_MALAISE_TRAP", label: "Townes-style Malaise trap" },
  BARTAK_STYLE_MALAISE_TRAP: { key: "BARTAK_STYLE_MALAISE_TRAP", label: "Bärták-style Malaise trap" },
  SLAM_TRAP: { key: "SLAM_TRAP", label: "SLAM trap (Sea, Land, and Air Malaise trap)" },
  EZ_MALAISE_TRAP: { key: "EZ_MALAISE_TRAP", label: "EZ-Malaise trap" },
  WINDOW_MALAISE_TRAP: { key: "WINDOW_MALAISE_TRAP", label: "Window Malaise trap" },
  CLASSIC_MALAISE_TRAP: { key: "CLASSIC_MALAISE_TRAP", label: "Classic Malaise trap" },
  PITFALL_TRAP: { key: "PITFALL_TRAP", label: "Pitfall trap" },
  BARRIER_PITFALL_TRAP: { key: "BARRIER_PITFALL_TRAP", label: "Barrier pitfall trap" },
  PAN_TRAP: { key: "PAN_TRAP", label: "Pan trap (Yellow pan, Blue pan, White pan)" },
  STICKY_TRAP: { key: "STICKY_TRAP", label: "Sticky trap (Glue trap)" },
  LIGHT_TRAP: { key: "LIGHT_TRAP", label: "Light trap" },
  UV_LIGHT_TRAP: { key: "UV_LIGHT_TRAP", label: "UV light trap" },
  LED_LIGHT_TRAP: { key: "LED_LIGHT_TRAP", label: "LED light trap" },
  ROBINSON_TRAP: { key: "ROBINSON_TRAP", label: "Robinson trap" },
  HEATH_TRAP: { key: "HEATH_TRAP", label: "Heath trap" },
  LINDGREN_FUNNEL_TRAP: { key: "LINDGREN_FUNNEL_TRAP", label: "Lindgren funnel trap" },
  WINDOW_FLIGHT_TRAP: { key: "WINDOW_FLIGHT_TRAP", label: "Window flight trap" },
  WINKLER_EXTRACTOR: { key: "WINKLER_EXTRACTOR", label: "Winkler extractor" },
  BERLESE_TULLGREN_FUNNEL: { key: "BERLESE_TULLGREN_FUNNEL", label: "Berlese funnel / Tullgren funnel" },
  FLIGHT_INTERCEPTION_TRAP: { key: "FLIGHT_INTERCEPTION_TRAP", label: "Flight interception trap" },
  EMERGENCE_TRAP: { key: "EMERGENCE_TRAP", label: "Emergence trap" },
  FEROMONE_TRAP: { key: "FEROMONE_TRAP", label: "Feromone trap" },
  BAIT_TRAP: { key: "BAIT_TRAP", label: "Bait trap" },
  CARRION_TRAP: { key: "CARRION_TRAP", label: "Carrion trap" },
  BEER_TRAP: { key: "BEER_TRAP", label: "Beer trap" },
  SLF_CIRCLE_TRAP: { key: "SLF_CIRCLE_TRAP", label: "SLF circle trap (for spotted lanternfly)" },
  CONE_TRAP: { key: "CONE_TRAP", label: "Cone trap" },
  DELTA_TRAP: { key: "DELTA_TRAP", label: "Delta trap" }
};
